import * as opsService from "./Ops";

export const GetPriceFunCom = async (symbol) => {
    console.log(symbol,"symbol343345")
  let result = await opsService.getData(
    "https://fapi.binance.com/fapi/v1/ticker/24hr?symbol=" + symbol
  );
  return result;
};
